module.exports = __webpack_public_path__ + "static/media/demand-sales-side.bf1b612e.jpg";